<template>
  <div class="topup-header">
    <div class="topup-header-main" :class="{fullWidth: !canShowBanner()}">
      <a class="logo" href="/">
        <img alt="logo" src="../../assets/images/logo.jpg" title="wRodzinie"/>
      </a>
      <div class="slogan">Doładowanie <span class="no-wrap">on-line</span></div>
    </div>
    <div class="topup-header-banner" v-if="canShowBanner()"></div>
  </div>
</template>

<script>
import { ROUTING } from '../../const/routing.const'

export default {
  name: 'TopupHeader',
  methods: {
    canShowBanner () {
      return this.$route.path === ROUTING.main
    }
  }
}
</script>

<style src="../../assets/scss/header.scss" lang="scss"></style>
